import AuditAdjustmentList from '@/pages/components/audit/adjustment/AuditAdjustmentList';

export default {
  list: AuditAdjustmentList,
};